<template>
  <v-container grid-list-xl pa-0>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-container>
        <v-layout>
          <v-flex xs12 md12>
            <v-autocomplete
              :items="filteredPowerPlants"
              item-text="name"
              item-value="power_plant_id"
              prepend-icon="flash_on"
              label="Planta"
              v-model="power_plant"
              return-object
              :rules="[
                (v) => !!v || 'Selecione a Planta que deseja ver fatura',
              ]"
            ></v-autocomplete>
          </v-flex>

          <v-flex xs12 md4 d-flex>
            <v-flex xs12 md12 class="text-lg-right">
              <v-btn
                color="primary"
                @click="validate()"
                :disabled="!valid || loading"
              >
                <v-icon>chart-bell-curve</v-icon>OK
              </v-btn>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </v-container>
</template>
<script>
import { EventBus } from "../../utils/event-bus";
import { GET_ALL_BILLING_TOTAL } from "../../graphql/billing";
import { mapState } from "vuex";
export default {
  props: ["power_plants"],
  data: () => ({
    loading: false,
    valid: false,
    power_plant: "",
    invoices: [],
    consumerunits: [],
  }),
  created() {
    if (this.user.power_plants && this.user.power_plants.length === 1) {
      this.power_plant = this.user.power_plants[0];
      this.getBillingTotal(this.power_plant.power_plant_id);
    }
  },
  computed: {
    ...mapState(["user"]),
    filteredPowerPlants() {
      // console.log('group', this.user.group.indexOf('admin'))
      // if (this.user.group === "admin") return this.power_plants
      if (
        this.user.group.indexOf("admin") === 0 ||
        this.user.group.indexOf("financial") === 0
      )
        return this.power_plants;
      var PowerPlantArray = [];
      if (this.power_plants && this.user.power_plants) {
        this.power_plants.filter((power_plant) => {
          return this.user.power_plants.filter((power_plant2) => {
            if (power_plant2.power_plant_id === power_plant.power_plant_id) {
              PowerPlantArray.push(power_plant);
            }
          });
        });
      }
      return PowerPlantArray;
    },
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        (this.valid = true), (this.loading = true);
        this.getBillingTotal(this.power_plant.power_plant_id);
      }
    },
    getBillingTotal(power_plant_id) {
      this.$apollo
        .query({
          // gql query
          query: GET_ALL_BILLING_TOTAL,
          // Reactive parameters
          variables: {
            // Use vue reactive properties here
            power_plant_id: power_plant_id,
            count: 12,
            page: 1,
            // status: "activated"
          },
        })
        .then((billings) => {
          // Seta as faturas no eventBus para o outro Componente
          this.invoices = billings.data.billingTotals;
          this.consumerunits = billings.data.consumerunits;
          EventBus.$emit("PowerPlant", power_plant_id);
          EventBus.$emit("LoadTotalInvoice", billings.data.billingTotals);
          EventBus.$emit("LoadCustomers", billings.data.consumerunits);
          this.valid = true;
          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
          this.valid = true;
          this.loading = false;
        });
    },
  },
  beforeDestroy() {
    //do something before destroying vue instance
    EventBus.$off("LoadTotalInvoice");
    EventBus.$off("LoadCustomers");
  },
};
</script>
